var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"singout",on:{"click":_vm.singout}},[_c('span',{staticClass:"text"},[_vm._v("Odjavi se")]),_c('i',{staticClass:"fas fa-sign-out-alt text-yellow ml-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }